module.exports = __webpack_public_path__ + "img/reviews-hero.606ac815.png";